<template>
    <div class="property-editor">
      <div class="property-blocks">
        <div v-for="(block, blockIndex) in propertyBlocks" 
             :key="blockIndex + dataChange" 
             class="property-block">
          <div class="block-content">
            <div class="property-name">
              <div class="label">属性</div>
              <el-input 
                v-model="block.name"
                placeholder="请输入属性名称"
                @change="handleNameChange(blockIndex)"
                :class="{ 'is-error': showError && !block.name }"
              />
            </div>
            
            <div class="property-values">
              <div class="label">属性详细规格</div>
              <div class="values-grid">
                <el-input
                  v-for="(item, index) in block.items"
                  :key="index"
                  v-model="item.value"
                  placeholder="请输入属性值"
                  :class="{ 'is-error': showError && !item.value }"
                  @change="handleValueChange(blockIndex, index)"
                />
              </div>
            </div>
          </div>
          
          <div class="block-actions">
            <el-button 
              icon="el-icon-top" 
              @click="moveBlock(blockIndex, -1)"
              :disabled="blockIndex === 0"
            />
            <el-button 
              icon="el-icon-delete" 
              @click="deleteBlock(blockIndex)"
            />
            <el-button 
              icon="el-icon-bottom" 
              @click="moveBlock(blockIndex, 1)"
              :disabled="blockIndex === propertyBlocks.length - 1"
            />
          </div>
        </div>
      </div>
      
      <el-button 
        type="primary" 
        icon="el-icon-plus"
        @click="addPropertyBlock"
      >
        添加属性
      </el-button>
       <el-alert
        v-if="showError"
        :title="errorMessage"
        type="error"
        :closable="false"
        style="margin-top: 10px;"
        show-icon>
      </el-alert>
    </div>
  </template>
  
  <script>
  export default {
    name: 'PropertyEditor',
    model: {
      prop: 'value', // 指定绑定的 prop 名（默认是 'value'）
      event: 'input'
    },
    props: {
        value: {
        type: Array,
        default: () => []
        },
        spuId: Number,
    },
    watch:{
        value: {
            handler(newVal) {
                if (newVal && newVal.length) {
                    this.initData(newVal);
                }
            },
            immediate: true
        },
        propertyBlocks: {
          handler(newVal) {
            console.log('propertyBlocks changed', newVal)
            this.getData()
            // 处理变化逻辑
          },
          deep: true // 深度监听
        },
    },
    data() {
      return {
        propertyBlocks: [],
        showError: false,
        dataChange: 0,
        errorMessage:'',
      };
    },
    
    computed: {
      hasError() {
        return this.propertyBlocks.some(block => 
          !block.name || block.items.some(item => !item.value)
        );
      },
      
      formattedData() {
        const result = [];
        let that = this
        this.propertyBlocks.forEach(block => {
          block.items.forEach(item => {
            // if (item.value) {
              result.push({
                id: item.id || `${Date.now()}-${Math.random()}`,
                spuId: that.spuId,
                no: item.no || 0,
                name: block.name || '',
                value: item.value || ''
              });
            // }
          });
        });
        return result;
      },
    },
    
    methods: {
      handleValueChange(blockIndex, itemIndex) {
        this.$set(this.propertyBlocks[blockIndex].items, itemIndex, {
          ...this.propertyBlocks[blockIndex].items[itemIndex]
        });
        this.$emit('input', this.formattedData);
      },
      
      handleNameChange(index) {
        this.$set(this.propertyBlocks,  index, {...this.propertyBlocks[index]}); 
        this.$emit('input', this.formattedData); 
      },
      initData(data) {
        let that = this
        if (!data || !data.length) return;
        
        const groups = data.reduce((acc, curr) => {
          if (!acc[curr.name]) {
            acc[curr.name] = [];
          }
          acc[curr.name].push(curr);
          return acc;
        }, {});
        
        this.propertyBlocks = Object.entries(groups).map(([name, items]) => {
          const block = {
            name,
            items: Array(9).fill(null).map(() => ({ 
              id: `${Date.now()}-${Math.random()}`,
              spuId: that.spuId,
              no: 0,
              name,
              value: ''     
            }))
          };
          
          items.forEach((item, index) => {
            if (index < 9) {
              block.items[index] = {
                id: item.id,
                value: item.value,
                no: item.no || index,
                name:item.name,
                spuId: item.spuId || that.spuId,
                value: item.value || '',
              };
            }
          });
          
          return block;
        });
      },
      
      addPropertyBlock() {
        let that = this
        const newBlock = {
          name: '',
          items: Array(9).fill(null).map((_, index) => ({ 
            id: `${Date.now()}-${Math.random()}`,  // 修改 id 生成方式，确保唯一性
            spuId: that.spuId,
            no: (this.propertyBlocks.length + 1) ,  // 修正序号计算
            value: ''
          }))
        };
        this.dataChange = this.dataChange +1;
       
        this.$set(this.propertyBlocks, this.propertyBlocks.length, newBlock);
        this.$nextTick(() => {
          this.$emit('input', this.formattedData);  // 在 nextTick 中触发更新
        });
      },
      
      moveBlock(index, direction) {
        const newIndex = index + direction;
        if (newIndex >= 0 && newIndex < this.propertyBlocks.length) {
          const blocks = [...this.propertyBlocks];
          const temp = blocks[index];
          blocks[index] = blocks[newIndex];
          blocks[newIndex] = temp;
          this.propertyBlocks = blocks;
        }
        this.dataChange += 1
        this.$emit('input', this.formattedData);
      },
      
      deleteBlock(index) {
        this.$confirm('确认删除该属性？', '提示', {
          type: 'warning'
        }).then(() => { 
          this.propertyBlocks.splice(index, 1);
          this.$emit('input', this.formattedData);
        }).catch(() => {});
      },
      
      validate() {
        // 检查属性名称和值
        for (const block of this.propertyBlocks) {
          // 如果属性名为空，直接返回
          if (!block.name) {
            this.showError = true;
            this.errorMessage = '属性名称不能为空';
            return false;
          }
          
          // 获取所有非空的属性值
          const values = block.items
            .map(item => item.value)
            .filter(value => value);
          
          // 检查重复值
          const uniqueValues = new Set(values);
          if (values.length !== uniqueValues.size) {
            this.showError = true;
            this.errorMessage = `属性【${block.name}】中存在重复的属性值`;
            return false;
          }
          
          // 检查空值
          for (const [index, item] of block.items.entries()) {
            if (!item.value) {
              this.showError = true;
              this.errorMessage = `属性【${block.name}】的第${index + 1}个值为空`;
              return false;
            }
          }
        }
        
        this.showError = false;
        this.errorMessage = '';
        return true;
      },
      
      getData() {
        if (!this.validate()) {
          return null;
        }
        return this.formattedData;
      },

      // handleInputChange({e, index, blockIndex, title, value}) {
      //   if (this.updateTimer) {
      //     clearTimeout(this.updateTimer);
      //   }
        
      //   this.updateTimer = setTimeout(() => {
      //     if (typeof blockIndex === 'number' && blockIndex >= 0) {
      //       if (typeof index === 'number' && index >= 0) {
      //         this.$set(this.propertyBlocks[blockIndex].items[index], 'value', e || '');
      //       } else {
      //         this.$set(this.propertyBlocks[blockIndex], 'name', e || '');
      //       }
      //     }

      //     this.showError = this.hasError;
      //     this.$emit('input', this.formattedData);
      //   }, 100);
      // },
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .property-editor {
    padding: 20px;
    .el-alert {
      margin-top: 10px;
    }
  }
  
  .property-block {
    border: 1px solid #EBEEF5;
    border-radius: 4px;
    padding: 20px;
    margin-bottom: 20px;
    display: flex;
    gap: 20px;
  }
  
  .block-content {
    flex: 1;
    display: flex;
  }
  
  .block-actions {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  
  .property-name {
    margin-bottom: 20px;
  }
  
  .values-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
  }
  
  .label {
    margin-bottom: 8px;
    color: #606266;
  }
  
  .add-value-btn {
    height: 40px;
    border-style: dashed;
  }
  
  .is-error {
    :deep(.el-input__inner) {
      border-color: #F56C6C;
    }
  }
  
  .error-tip {
    color: #F56C6C;
    font-size: 12px;
    margin-top: 10px;
    line-height: 1.5;
  }
  </style>
